import { Text } from '@fable/components'
import { css, useTheme } from '@fable/theme'
import { StatsScreenshotButton } from '../../shared/screenshot/StatsScreenshotButton'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'
import { ReaderSummaryScreenshotContent } from './ReaderSummaryScreenshotContent'
import { analytics } from 'segment_analytics'

export const ReaderSummaryScreenshotButton = () => {
  const { colors } = useTheme()
  const theme = useStatsTheme((s) => s.theme)

  return (
    <StatsScreenshotButton
      className={css`
        width: 100%;
        height: 52px;
        border-radius: 100px;
        background-color: ${colors.uiWhite};
        &:hover {
          background-color: ${colors.uiWhite};
        }
      `}
      iconColor={theme.colors.primary}
      content={
        <Text
          className={css`
            font-size: 14px;
            line-height: 16px;
            letter-spacing: -0.3px;
            will-change: color;
          `}
          type="body"
          color={theme.colors.hero.shareTextColor}
          weight="600"
        >
          Share
        </Text>
      }
      screenshotStyles={css`
        padding-bottom: 40px;
      `}
      onClick={() =>
        analytics.events.stats.statsShareTap({ type: 'reader_summary' })
      }
    >
      <ReaderSummaryScreenshotContent />
    </StatsScreenshotButton>
  )
}
